<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content shadow-lg" style="min-width: 600px; background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <p class="h3 text-seccess fw-bold">Please Enter Credit Amount</p>
                        <br>
                        <input type="text" class="form-control input-lg" name="creditAmount"  v-on:keyup.enter="passCreditAmount()" id="creditAmount" v-model="selfCreditAmount" @input="selfCreditAmount = Math.min(selfCreditAmount, creditAmount)" :placeholder="creditAmount" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />
                    
                        <br>    
                            <div style="display:flex; justify-content: space-between; margin-top: 20px; padding: 0 10px;">
                                
                                <button @click="closePopUp" class="btn btn-danger btn-lg" style="min-width: 120px;">Close</button>                                    
                                <button class="btn btn-success btn-lg" @click="passCreditAmount()" style="min-width: 120px;">Add Payment</button>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="col-sm-4"
                style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-left: -15px;margin-right: -10px;">
                <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true" />
            </div>
        </div>
    </transition>
</template>
<script>

import commonServices from "@/shared/commonServices"
import numericpad from "@/components/SimpleKeyboard";
export default {
    components:{
        numericpad
    },
    mixins: [commonServices],
    name:"PayCredit",
    data: function(){
        return {
            selfCreditAmount: '',
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.selfCreditAmount = '';
            }
        }
    },
    methods:{
        onInput(key) {
            if (key == 11) {
                    this.selfCreditAmount = (this.selfCreditAmount + '0')
            } else {
                this.selfCreditAmount = (this.selfCreditAmount + key)
            }
            //this.getProduct(this.barcode);

        },
        onDelete() {
            this.selfCreditAmount = this.selfCreditAmount.slice(0, this.selfCreditAmount.length - 1);
        },
        onReset() {
            this.selfCreditAmount = "";
        },
        closePopUp(){            this.selfCreditAmount = '';            this.close();        },

        passCreditAmount()
        {
            let amount = this.selfCreditAmount;

            if (!amount) {
                amount = this.creditAmount;
            }
            this.$emit('getCreditAmount', amount);
            this.selfCreditAmount = ''
            this.close();
        },
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
        creditAmount: {
            type:String,
            required:true
        },        

    },
    mounted(){
        if (this.open) {
            this.selfCreditAmount = '';
        }
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}
.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
